import { render, staticRenderFns } from "./setDialog.vue?vue&type=template&id=2a974c60&scoped=true&"
import script from "./setDialog.vue?vue&type=script&lang=js&"
export * from "./setDialog.vue?vue&type=script&lang=js&"
import style0 from "./setDialog.vue?vue&type=style&index=0&id=2a974c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a974c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a974c60')) {
      api.createRecord('2a974c60', component.options)
    } else {
      api.reload('2a974c60', component.options)
    }
    module.hot.accept("./setDialog.vue?vue&type=template&id=2a974c60&scoped=true&", function () {
      api.rerender('2a974c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/setDialog.vue"
export default component.exports